module.exports = {
  accountType: require('./accountType'),
  event: require('./event'),
  operation: require('./operation'),
  paymentMethod: require('./paymentMethod'),
  payoutRefundReason: require('./payoutRefundReason'),
  pixKeyType: require('./pixKeyType'),
  pixPriority: require('./pixPriority'),
  status: require('./status'),
  spiType: require('./spiType')
};
